// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';

// eslint-disable-next-line import/no-cycle
import { getProductComponent } from '../tools';

type Props = {
  option: DecoratedProduct,
};

export function DomainTransferOption({ option }: Props): React.MixedElement {
  const Renderer = getProductComponent(option.component);

  return <Renderer product={option} />;
}
